import React, { FunctionComponent } from 'react';
import { IMetaFields } from '../../../@types/generated/contentful';
import { friendlyDate } from '../../../helpers/dateTime';
import { defaultMetaTags } from '../../../services/constants';
import ProfilePic from '../../profilePic';

type Props = {
    meta: IMetaFields | undefined,
    date: string
};

const BlogPostAuthor: FunctionComponent<Props> = ({ meta, date }) => {
    const metaContent = (meta !== undefined) ? meta : defaultMetaTags

    return (
        <div className="flex items-center">
            <ProfilePic
                image={metaContent.author?.fields.profilePic?.fields.file.url}
                name={metaContent.author?.fields.name}
                className="mr-2"
            />
            <ul>
                <li className="body-small flex">
                    {friendlyDate(date)}
                </li>
                <li className="sub-heading-medium">
                    {metaContent.author?.fields.name || "SponsorPulse Staff"}
                </li>
            </ul>
        </div>
    );
};

export default BlogPostAuthor;